import { BrandingApiResponse } from '../theme/types';
import apiClient from './api';

type BrandingEnvelope = {
  success?: boolean;
  data?: BrandingApiResponse;
};

/**
 * Fetch branding configuration from backend
 * Requires Firebase authentication token
 */
export async function fetchBrandingConfig(): Promise<BrandingApiResponse | null> {
  try {
    const response = await apiClient.get<BrandingApiResponse | BrandingEnvelope>('/branding');
    const payload = response.data;

    if (payload && typeof payload === 'object' && 'data' in payload) {
      return (payload as BrandingEnvelope).data ?? null;
    }

    return payload as BrandingApiResponse;
  } catch (error: any) {
    const status = error?.response?.status;
    const data = error?.response?.data;
    console.warn('Failed to fetch branding config, using default theme:', { status, data, error });
    return null;
  }
}

export const brandingService = {
  fetchBrandingConfig,
};
